import styled, { css } from 'styled-components';

interface IStyContainerIcon {
  $hasOnClick: boolean;
}

export const StyContainerIcon = styled.div<IStyContainerIcon>`
  display: flex;
  cursor: pointer;

  ${({ $hasOnClick }) =>
    !$hasOnClick &&
    css`
      cursor: inherit;
      user-select: none;
    `}
`;
